import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiService from "../nhrc_apis/ApiService";

const { TalentPublicationsAPI } = ApiService;

function Talentsection() {
  const [formData, setFormData] = useState({
    title: "",
    banner1: null,
    banner2: null,
    banner3: null,
    banner4: null,
    doc1: null,
    doc2: null,
    doc3: null,
    doc4: null,
    youtube_url: "",
  });

  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, [field]: file }));
    }
  };

  const handleInputChange = (e, field) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const uploadFile = async (file, fieldName, type = "image") => {
    setUploadProgress((prev) => ({ ...prev, [fieldName]: "uploading" }));
    try {
      let response;
      if (type === "pdf") {
        response = await TalentPublicationsAPI.uploadPdf(file);
      } else {
        response = await TalentPublicationsAPI.uploadImage(file);
      }

      const url =
        response?.data?.file_url ||
        response?.data?.url ||
        response?.data?.path ||
        (typeof response?.data === "string" ? response.data : "");

      if (!url) {
        throw new Error(`Empty URL returned for ${fieldName}`);
      }

      setUploadProgress((prev) => ({ ...prev, [fieldName]: "done" }));
      return url;
    } catch (err) {
      setUploadProgress((prev) => ({ ...prev, [fieldName]: "error" }));
      throw new Error(`Failed to upload ${fieldName}: ${err?.message}`);
    }
  };

  const uploadAllFiles = async () => {
    const results = {};

    const uploads = [
      { key: "banner_image_1", field: "banner1", type: "image" },
      { key: "banner_image_2", field: "banner2", type: "image" },
      { key: "banner_image_3", field: "banner3", type: "image" },
      { key: "banner_image_4", field: "banner4", type: "image" },
      { key: "document_1",     field: "doc1",    type: "pdf"   },
      { key: "document_2",     field: "doc2",    type: "pdf"   },
      { key: "document_3",     field: "doc3",    type: "pdf"   },
      { key: "document_4",     field: "doc4",    type: "pdf"   },
    ];

    for (const item of uploads) {
      if (!formData[item.field]) continue;
      results[item.key] = await uploadFile(
        formData[item.field],
        item.field,
        item.type
      );
    }

    return results;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title.trim())       { toast.error("Please enter a Title");         return; }
    if (!formData.banner1)            { toast.error("Please upload Banner 1 Image"); return; }
    if (!formData.doc1)               { toast.error("Please upload Document 1");     return; }
    if (!formData.banner2)            { toast.error("Please upload Banner 2 Image"); return; }
    if (!formData.doc2)               { toast.error("Please upload Document 2");     return; }
    if (!formData.banner3)            { toast.error("Please upload Banner 3 Image"); return; }
    if (!formData.doc3)               { toast.error("Please upload Document 3");     return; }
    if (!formData.banner4)            { toast.error("Please upload Banner 4 Image"); return; }
    if (!formData.doc4)               { toast.error("Please upload Document 4");     return; }
    if (!formData.youtube_url.trim()) { toast.error("Please enter YouTube URL");     return; }

    setLoading(true);
    setUploadProgress({});

    try {
      toast.info("Uploading files, please wait...", {
        autoClose: false,
        toastId: "uploading",
      });

      const uploadedUrls = await uploadAllFiles();

      toast.dismiss("uploading");

      const payload = {
        title:          formData.title.trim(),
        banner_image_1: uploadedUrls.banner_image_1 || null,
        banner_image_2: uploadedUrls.banner_image_2 || null,
        banner_image_3: uploadedUrls.banner_image_3 || null,
        banner_image_4: uploadedUrls.banner_image_4 || null,
        document_1:     uploadedUrls.document_1     || null,
        document_2:     uploadedUrls.document_2     || null,
        document_3:     uploadedUrls.document_3     || null,
        document_4:     uploadedUrls.document_4     || null,
        youtube_url:    formData.youtube_url.trim(),
        display_order:  1,
      };

      console.log("Submitting payload:", payload);

      toast.info("Saving publication...", {
        autoClose: false,
        toastId: "saving",
      });

      const res = await TalentPublicationsAPI.createPublication(payload);

      console.log("Create response:", res?.data);

      toast.dismiss("saving");
      toast.success("Talent Publication saved successfully! 🎉");

      setFormData({
        title: "",
        banner1: null,
        banner2: null,
        banner3: null,
        banner4: null,
        doc1: null,
        doc2: null,
        doc3: null,
        doc4: null,
        youtube_url: "",
      });
      setUploadProgress({});

      document
        .querySelectorAll("input[type='file']")
        .forEach((el) => (el.value = ""));

    } catch (err) {
      toast.dismiss("uploading");
      toast.dismiss("saving");
      console.error("Submit error:", err);
      toast.error(
        err?.response?.data?.detail ||
        err?.message ||
        "Failed to save. Please check your connection and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const StatusBadge = ({ field }) => {
    const status = uploadProgress[field];
    if (!status) return null;
    if (status === "uploading") return <span className="badge bg-warning text-dark ms-2">Uploading...</span>;
    if (status === "done")      return <span className="badge bg-success ms-2">Uploaded ✓</span>;
    if (status === "error")     return <span className="badge bg-danger ms-2">Failed ✗</span>;
    return null;
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1600} />

      <div className="container mt-4 mb-5">
        <h4 className="mb-4 text-danger fw-bold">
          NHRC - Talent Publication (Admin)
        </h4>

        <form
          className="p-3 border rounded shadow-sm bg-white"
          onSubmit={handleSubmit}
        >
          {/* Title */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Title *</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter publication title"
              value={formData.title}
              onChange={(e) => handleInputChange(e, "title")}
            />
          </div>

          {/* Banner 1 + Doc 1 */}
          <div className="mb-0 d-flex gap-3">
            <div style={{ width: "50%" }}>
              <label className="form-label">
                Upload Banner 1 Img * <StatusBadge field="banner1" />
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                className="form-control"
                onChange={(e) => handleFileChange(e, "banner1")}
              />
              <div className="d-flex justify-content-between" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>W816 x H1056</p>
                <p>Upload JPG/PNG Minimum 1 To 2MB</p>
              </div>
            </div>
            <div className="mb-2" style={{ width: "50%" }}>
              <label className="form-label">
                Upload Document 1 * <StatusBadge field="doc1" />
              </label>
              <input
                type="file"
                accept="application/pdf"
                className="form-control"
                onChange={(e) => handleFileChange(e, "doc1")}
              />
              <div className="d-flex justify-content-end" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>Upload PDF Minimum 2 To 10MB</p>
              </div>
            </div>
          </div>

          {/* Banner 2 + Doc 2 */}
          <div className="mb-0 d-flex gap-3">
            <div style={{ width: "50%" }}>
              <label className="form-label">
                Upload Banner 2 Img * <StatusBadge field="banner2" />
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                className="form-control"
                onChange={(e) => handleFileChange(e, "banner2")}
              />
              <div className="d-flex justify-content-between" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>W816 x H1056</p>
                <p>Upload JPG/PNG Minimum 1 To 2MB</p>
              </div>
            </div>
            <div className="mb-2" style={{ width: "50%" }}>
              <label className="form-label">
                Upload Document 2 * <StatusBadge field="doc2" />
              </label>
              <input
                type="file"
                accept="application/pdf"
                className="form-control"
                onChange={(e) => handleFileChange(e, "doc2")}
              />
              <div className="d-flex justify-content-end" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>Upload PDF Minimum 2 To 10MB</p>
              </div>
            </div>
          </div>

          {/* Banner 3 + Doc 3 */}
          <div className="mb-0 d-flex gap-3">
            <div style={{ width: "50%" }}>
              <label className="form-label">
                Upload Banner 3 Img * <StatusBadge field="banner3" />
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                className="form-control"
                onChange={(e) => handleFileChange(e, "banner3")}
              />
              <div className="d-flex justify-content-between" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>W816 x H1056</p>
                <p>Upload JPG/PNG Minimum 1 To 2MB</p>
              </div>
            </div>
            <div className="mb-2" style={{ width: "50%" }}>
              <label className="form-label">
                Upload Document 3 * <StatusBadge field="doc3" />
              </label>
              <input
                type="file"
                accept="application/pdf"
                className="form-control"
                onChange={(e) => handleFileChange(e, "doc3")}
              />
              <div className="d-flex justify-content-end" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>Upload PDF Minimum 2 To 10MB</p>
              </div>
            </div>
          </div>

          {/* Banner 4 + Doc 4 */}
          <div className="mb-0 d-flex gap-3">
            <div style={{ width: "50%" }}>
              <label className="form-label">
                Upload Banner 4 Img * <StatusBadge field="banner4" />
              </label>
              <input
                type="file"
                accept="image/jpeg,image/png,image/webp"
                className="form-control"
                onChange={(e) => handleFileChange(e, "banner4")}
              />
              <div className="d-flex justify-content-between" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>W816 x H1056</p>
                <p>Upload JPG/PNG Minimum 1 To 2MB</p>
              </div>
            </div>
            <div className="mb-2" style={{ width: "50%" }}>
              <label className="form-label">
                Upload Document 4 * <StatusBadge field="doc4" />
              </label>
              <input
                type="file"
                accept="application/pdf"
                className="form-control"
                onChange={(e) => handleFileChange(e, "doc4")}
              />
              <div className="d-flex justify-content-end" style={{ color: "#333", fontSize: "0.7rem" }}>
                <p>Upload PDF Minimum 2 To 10MB</p>
              </div>
            </div>
          </div>

          {/* YouTube URL */}
          <div className="mb-3">
            <label className="form-label fw-semibold">YouTube URL *</label>
            <input
              type="text"
              className="form-control"
              placeholder="https://www.youtube.com/watch?v=..."
              value={formData.youtube_url}
              onChange={(e) => handleInputChange(e, "youtube_url")}
            />
          </div>

          <button
            type="submit"
            className="btn btn-success px-5"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Saving...
              </>
            ) : (
              "SUBMIT"
            )}
          </button>
        </form>
      </div>
    </>
  );
}

export default Talentsection;